import Icon from 'veui/components/Icon'

Icon.register({
  key: {
    paths: [
      {
        d: 'M726.63 201.37L669.26 144l25.37-25.37a32 32 0 00-45.26-45.26L422.16 300.58a223.92 223.92 0 1045.26 45.26L528 285.26l57.37 57.37a32 32 0 0045.26-45.26L573.26 240 624 189.26l57.37 57.37a32 32 0 0045.26-45.26zM288 640c-88.22 0-160-71.78-160-160s71.78-160 160-160 160 71.78 160 160-71.78 160-160 160z'
      }
    ],
    width: '768',
    height: '768'
  }
})
